export const ELECTRIC = 1;
export const BTU = 2;
export const THERMS = 3;
export const STEAM = 4;
export const TONS = 5;
export const KVAR = 6;
export const CCF_WATER = 7;
export const GALLONS = 8;
export const CCG_GAS = 9;
export const DEG_F = 10;
export const DEG_C = 11;
export const AQI = 12;
export const PPM = 13;
export const PPB = 14;
export const PERCENT = 15;
export const VOLTS = 16;
export const AMPS = 17;
export const HZ = 18;
export const KVA = 19;
export const POWER_FACTOR = 20;
export const PSI = 21;
export const KW_TON = 22;
export const MLBS_TON = 23;
export const RH = 24;
export const UG_CUBIC_M = 25;
export const GAL_PER_MIN = 26;
export const METRIC_TON = 27;
export const LUX = 28;
export const NOT_APPL = 29;
export const OCCUPANCY = 30;
export const IAQ = 31;
export const DOLLARS_HR = 32;
export const KBTU_WATER = 33;
export const MILLIBAR = 34;
export const DB_AUDIO = 35;
export const FEET_PER_MIN = 36;
